var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"support page-main"},[_c('section',{staticClass:"page-heading-wrap"},[_c('h3',{staticClass:"page-heading"},[_vm._v(_vm._s(_vm.$t('question.title')))])]),_c('tab',{attrs:{"tab-list":_vm.tabList}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }